import * as React from "react";
import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { Strings } from "src/com/sixdee/crbtportal/utils/resources/strings";
import { AlertComponent } from "../../../toolkit/alert/alertcomponent";
import { AlertType } from "../../../toolkit/alert/alerttype";
import { LoaderComponent } from "../../../toolkit/loader/loadercomponent";
import { UIComponentHandler } from "../../../toolkit/uicomponent";
import { LoaderWrapperComponent } from "../../popup/loaderwrappercomponent";
import { PopUpWrapperComponent } from "../../popup/popupwrappercomponent";
import { CRBTUIViewImpl } from "../crbt/crbtuiview";
import { TermsandConditionComponentProps, TermsandConditionComponentState } from "./termsandconditioncomponent";
import { TermsandConditionCSSStyle } from "./termsandconditioncss";
import "./termsandcondition-style.css";


export class TermsandConditionViewImpl extends CRBTUIViewImpl
{
     popupComponent:PopUpWrapperComponent ;
    private loaderWrapperComponent:LoaderWrapperComponent;

     
    constructor(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler)
    {
        super(applicationContext, uiComponentHandler);
    }

    bindHandlers()
    {
        this.showPopup = this.showPopup.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
    }
    getChildComponent(props: TermsandConditionComponentProps, state: TermsandConditionComponentState, cssStyle: TermsandConditionCSSStyle): JSX.Element
    {   
        return (
           
                <>
                     <div id="termsandcondition-web">
                       {
                           this.getWebView(props, state,cssStyle)
                       }
                   </div>
                   <div id="termsandcondition-mobile">
                       {
                           this.getMobileView(props, state, cssStyle)
                       }

                 </div>
                   <PopUpWrapperComponent ref={(item: any) => this.popupComponent = item} context={props.context}/>
        <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </>
        );
    }

    getWebView(props: TermsandConditionComponentProps, state: TermsandConditionComponentState, cssStyle: TermsandConditionCSSStyle)
    {
        return (
            <div style={{paddingLeft: "5%", paddingRight: "5%"}}>
            <label style={cssStyle.getTextCSSStyle()}>
                    {props.context.getResources().getString(Strings.terms_condition)}
            </label>
            <label style={cssStyle.getTitleTextCSSStyle()}>
            {
                props.context.getResources().getString(Strings.terms_conditions_content)}
            </label>
           
            </div>
        );
    }

    getMobileView(props: TermsandConditionComponentProps, state: TermsandConditionComponentState, cssStyle: TermsandConditionCSSStyle)
    {
        return (
            <>
            <label style={cssStyle.getMobileTextCSSStyle()}>
                    {props.context.getResources().getString(Strings.terms_condition)}
            </label>
            <label style={cssStyle.getMobileTitleTextCSSStyle()}>
            {
                props.context.getResources().getString(Strings.terms_conditions_content)}
            </label>
           
            </>
        );
    }

  
    showLoader()
    {
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    showPopup(msg: string, type: AlertType,title:string)
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(true, <AlertComponent buttonTitle={title} alertMessage={msg} alertType={type} onCloseButtonClick={this.closePopup} onClick={this.closePopup} context={this.getUIProps().context}/>);
    }
    
    closePopup()
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(false, <></>);
    }
    getNavigationPath()
    {
        return [this.getUIProps().context.getResources().getString(Strings.home),
                this.getUIProps().context.getResources().getString(Strings.terms_condition)];
    }

    getBannerImg()
    {
        return "categories.jpg";
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/termsandcondition/termsandconditionview.tsx